export default __webpack_public_path__ + "static/media/3.be4e2058.png";